module.exports = __webpack_public_path__ + "4db02b250288a29b97963fb850b332f9.png";